import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoSign',
  props: {
    target: null
  },
  setup(__props: any) {

const props = __props as { target: string }


const href = computed(() => `/#/`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(`${ props.target }-logo`),
    href: _unref(href)
  }, [
    _createElementVNode("p", null, [
      _createElementVNode("img", {
        class: _normalizeClass(`${ props.target }-logo-image sign-logo-image`),
        src: require(`@/assets/images/sign.png`),
        alt: "Sign",
        loading: "lazy"
      }, null, 10, _hoisted_2)
    ])
  ], 10, _hoisted_1))
}
}

})